import React, { Fragment } from "react";
import PropTypes from "prop-types";
import get from "lodash.get";
import { StoryCard } from "../../Molecules/StoryCard";
import { Headline } from "../../Atoms/Headline";
import { AuthorWithTime } from "../../Atoms/AuthorWithTimestamp";
import { SectionTag } from "../../Atoms/SectionTag/index";
import { getTextColor, getSlot, rgbToHex } from "../../../utils/utils";
import { CollectionName } from "../../Atoms/CollectionName";
import { LoadmoreButton } from "../../Atoms/Loadmore";
import { StateProvider } from "../../SharedContext";

import "./11-stories.m.css";
import { Subheadline } from "../../Atoms/Subheadline";

const ElevenStories = ({ collection, config = {} }) => {
  const {
    collectionNameBorderColor = "",
    borderColor = "",
    theme = "",
    slotConfig = [],
    withseparator,
    collectionNameTemplate = "",
    footerSlotConfig = {},
    footerButton = ""
  } = config;
  const { type = "story", component } = get(slotConfig, [0], {});
  const { footerSlot } = footerSlotConfig;
  const typeStory = get(collection, ["items"], []).filter((collections) => collections.type === "story");
  const items = typeStory || [];

  if (items.length < 1) {
    return null;
  }

  const textColor = getTextColor(theme);
  const SectionTagborderColor = rgbToHex(borderColor);
  const getChildCollectionData = () => {
    const filterCollection = get(collection, ["items"], []).find((collections) => collections.type === "collection");
    return (
      <div styleName="child-collection-wrapper">
        <CollectionName collection={filterCollection} collectionNameTemplate={collectionNameTemplate} headerLevel="5" />
        {items.slice(0, 1).map((item, index) => {
          const story = item.story;
          return (
            <div styleName="first-story-card" key={`story-${index}`}>
              <StoryCard story={story} theme={theme} headerLevel="4" border={withseparator ? "bottom" : ""}>
                <SectionTag story={story} borderColor={SectionTagborderColor} />
                <Headline story={story} />
                <AuthorWithTime story={story} hideAuthorImage={false} />
                <Subheadline story={story} />
              </StoryCard>
            </div>
          );
        })}
        {items.slice(1, 4).map((item, index) => {
          const story = item.story;
          return (
            <div styleName="story-card" key={`story-${index}`}>
              <StoryCard story={story} theme={theme} border={withseparator ? "bottom" : ""}>
                <SectionTag story={story} borderColor={SectionTagborderColor} />
                <Headline story={story} />
                <AuthorWithTime story={story} hideAuthorImage={false} />
              </StoryCard>
            </div>
          );
        })}
        {items.slice(4, 5).map((item, index) => {
          const story = item.story;
          return (
            <div styleName="story-card" key={`story-${index}`}>
              <StoryCard story={story} theme={theme}>
                <SectionTag story={story} borderColor={SectionTagborderColor} />
                <Headline story={story} />
                <AuthorWithTime story={story} hideAuthorImage={false} />
              </StoryCard>
            </div>
          );
        })}
      </div>
    );
  };

  const getLastSlotStoryData = () => {
    return (
      <div styleName="column-three">
        {items.slice(6, 7).map((item, index) => {
          const story = item.story;
          return (
            <div styleName="first-story-card" key={`story-${index}`}>
              <StoryCard story={story} theme={theme} border={withseparator ? "bottom" : ""}>
                <SectionTag story={story} borderColor={SectionTagborderColor} />
                <Headline story={story} />
                <AuthorWithTime story={story} hideAuthorImage={false} />
                <Subheadline story={story} clazzName="arr-hidden-mob" />
              </StoryCard>
            </div>
          );
        })}
        {items.slice(7, 10).map((item, index) => {
          const story = item.story;
          return (
            <div styleName="story-card" key={`story-${index}`}>
              <StoryCard story={story} theme={theme} border={withseparator ? "bottom" : ""}>
                <SectionTag story={story} borderColor={SectionTagborderColor} />
                <Headline story={story} />
                <AuthorWithTime story={story} hideAuthorImage={false} />
              </StoryCard>
            </div>
          );
        })}
        {items.slice(10, 11).map((item, index) => {
          const story = item.story;
          return (
            <div styleName="story-card" key={`story-${index}`}>
              <StoryCard story={story} theme={theme}>
                <SectionTag story={story} borderColor={SectionTagborderColor} />
                <Headline story={story} />
                <AuthorWithTime story={story} hideAuthorImage={false} />
              </StoryCard>
            </div>
          );
        })}
      </div>
    );
  };

  const slot = getSlot(type, component, getLastSlotStoryData, getChildCollectionData);
  const footerSlotComp = footerSlot ? footerSlot() : null;

  const getColumn = () => {
    if (withseparator) {
      return (
        <>
          <div styleName="wrapper-with-divider">
            <div styleName="column-one">
              {items.slice(2, 3).map((item, index) => {
                const story = item.story;
                return (
                  <div styleName="story-card" key={`story-${index}`}>
                    <StoryCard
                      story={story}
                      theme={theme}
                      border="bottom"
                      isHorizontalMobile
                      borderColor={SectionTagborderColor}
                      hideAuthorImage={false}
                      headerLevel="5"
                    />
                  </div>
                );
              })}
              {items.slice(3, 5).map((item, index) => {
                const story = item.story;
                return (
                  <Fragment key={`story-col-${index}-${get(story, ["id"], "0")}`}>
                    <div styleName="story-card" key={`story-${index}`}>
                      <StoryCard story={story} theme={theme} border={withseparator ? "bottom" : ""}>
                        <SectionTag story={story} borderColor={SectionTagborderColor} />
                        <Headline story={story} />
                        <AuthorWithTime story={story} hideAuthorImage={false} />
                      </StoryCard>
                    </div>
                  </Fragment>
                );
              })}
              {items.slice(5, 6).map((item, index) => {
                const story = item.story;
                return (
                  <Fragment key={`story-col2-${index}-${get(story, ["id"], "0")}`}>
                    <div styleName="story-card" key={`story-${index}`}>
                      <StoryCard story={story} theme={theme}>
                        <SectionTag story={story} borderColor={SectionTagborderColor} />
                        <Headline story={story} />
                        <AuthorWithTime story={story} hideAuthorImage={false} />
                      </StoryCard>
                    </div>
                  </Fragment>
                );
              })}
            </div>
            <div styleName={`divider ${textColor}`} />
            <div styleName="column-two">
              {items.slice(0, 1).map((item, index) => {
                const story = item.story;
                return (
                  <div styleName="story-card" key={`story-${index}`}>
                    <StoryCard
                      story={story}
                      theme={theme}
                      borderColor={SectionTagborderColor}
                      centerAlign
                      border="bottom"
                      headerLevel="3"
                      aspectRatio={[[16, 9], [16, 9]]}
                      hideAuthorImage={false}
                    />
                  </div>
                );
              })}
              {items.slice(1, 2).map((item, index) => {
                const story = item.story;
                return (
                  <div styleName="story-card" key={`story-${index}`}>
                    <StoryCard
                      story={story}
                      isHorizontal
                      theme={theme}
                      borderColor={SectionTagborderColor}
                      hideAuthorImage={false}
                      headerLevel="5"
                    />
                  </div>
                );
              })}
            </div>
            <div styleName={`divider ${textColor}`} />
            {slot}
          </div>
        </>
      );
    } else
      return (
        <>
          <div styleName="wrapper">
            <div styleName="column-one">
              {items.slice(2, 3).map((item, index) => {
                const story = item.story;
                return (
                  <div styleName="story-card" key={`story-${index}`}>
                    <StoryCard
                      story={story}
                      theme={theme}
                      borderColor={SectionTagborderColor}
                      isHorizontalMobile
                      headerLevel="5"
                      hideAuthorImage={false}
                    />
                  </div>
                );
              })}
              {items.slice(3, 6).map((item, index) => {
                const story = item.story;
                return (
                  <Fragment key={`story-col1-${get(story, ["id"], "0")}`}>
                    <div styleName="story-card" key={`story-${index}`}>
                      <StoryCard story={story} theme={theme}>
                        <SectionTag story={story} borderColor={SectionTagborderColor} />
                        <Headline story={story} />
                        <AuthorWithTime story={story} hideAuthorImage={false} />
                      </StoryCard>
                    </div>
                  </Fragment>
                );
              })}
            </div>
            <div styleName="column-two">
              {items.slice(0, 1).map((item, index) => {
                const story = item.story;
                return (
                  <div styleName="story-card" key={`story-${index}`}>
                    <StoryCard
                      story={story}
                      borderColor={SectionTagborderColor}
                      theme={theme}
                      headerLevel="3"
                      centerAlign
                      aspectRatio={[[16, 9], [16, 9]]}
                      hideAuthorImage={false}
                    />
                  </div>
                );
              })}
              {items.slice(1, 2).map((item, index) => {
                const story = item.story;
                return (
                  <div styleName="story-card" key={`story-${index}`}>
                    <StoryCard
                      story={story}
                      isHorizontal
                      theme={theme}
                      borderColor={SectionTagborderColor}
                      hideAuthorImage={false}
                      headerLevel="5"
                    />
                  </div>
                );
              })}
            </div>
            {slot}
          </div>
        </>
      );
  };
  return (
    <div className="full-width-with-padding arrow-component" style={{ backgroundColor: theme, color: textColor }}>
      <div styleName="eleven-stories">
        <CollectionName
          collection={collection}
          collectionNameTemplate={collectionNameTemplate}
          collectionNameBorderColor={collectionNameBorderColor}
        />
        {getColumn()}
        <LoadmoreButton collection={collection} template={footerButton} />
        {footerSlotComp}
      </div>
    </div>
  );
};

ElevenStories.propTypes = {
  /**  stories is the array of objects which is returning by API  */
  collection: PropTypes.object.isRequired,
  config: PropTypes.shape({
    borderColor: PropTypes.string,
    footerButton: PropTypes.string,
    theme: PropTypes.string,
    border: PropTypes.string,
    slotConfig: PropTypes.array,
    withseparator: PropTypes.bool,
    collectionNameTemplate: PropTypes.string,
    collectionNameBorderColor: PropTypes.string
  })
};

export default StateProvider(ElevenStories);
